import {
  Card as CardAntd,
  Table as TableAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const Title = styled(TypographyAntd.Title)`
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 23px !important;
  letter-spacing: 0.25px !important;
  color: #4f4f4f !important;
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 5px 5px !important;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table-thead > tr > th {
    font-weight: bold !important;
  }
`;
